import React from "react";
import { connect } from "react-redux";
import KitSensibilizacionPlanMovilidad from "./kit";
import { scrollElementToTop, dataLayerTag } from "../functions";

import { editarPlanMovilidad, handlerEstadoProcesoPlanMovilidad } from "../actions";

class MainSensibilizacionPlanMovilidad extends React.PureComponent {
  componentDidMount = () => {
    scrollElementToTop("mainContent");
  }


  render() {
    return (
      <div id="Sensibilizacion_plan_movilidad">
        <section id="content-etapa">
          <div className="container-fluid">
            <div className="row PM-plan-borde-spacing">
              <div className="col-md-12 text-center PM-tipo-denuncias-select">
                <div className="row text-center">
                  <div className="PM-section-title col-md-12 text-center">Para sensibilizar a los trabajadores puedes realizar 2 tipos de difusión de Planes de Movilidad:</div>
                  <div className="col-md-12 text-center">
                    <ul className="PM-titulo-etapa">
                      <li>a. Presencial: mediante reuniones plenarias con los trabajadores para explicar el proyecto.</li>
                      <li>b. Masiva: a través del envío de emails, instalación de afiches en el centro de trabajo y difusión de mensajes por WhatsApp.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center PM-plan-contador-tareas PM-home-item-plan">
                <ul>
                  <li className="PM-border-line">
                    <KitSensibilizacionPlanMovilidad />
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-md-8 text-left PM-info">
                        <p>¿Ya realizaste la difusión? Ahora continúa con la etapa 2: Diagnóstico.</p>
                      </div>
                      <div className="col-md-4 text-right PM-info">
                        <p><strong>Plazo recomendado:</strong> 1 semana</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="container-fluid PM-btn-box">
              <div className="text-center PM-plan-contador-finalizar">
                <div className="PM-home-item-plan">
                  <button
                    className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-dx-button-plan-aire PM-button-cierre"
                    onClick={() => {
                    // cambio la etapa del proceso
                      this.props.dispatch(handlerEstadoProcesoPlanMovilidad(2));
                      // envío la información
                      this.props.dispatch(editarPlanMovilidad(
                        this.props.idplanMovilidad,
                        this.props.estadoPlan,
                        this.props.estadoEjecucion,
                        2, // this.props.estadoProceso,
                        1, // paso a pestaña finalizar
                      ));
                      //gtd -> finalizo etapa 1 (sensibilización)
                      dataLayerTag({
                        'event': 'etapa_1_finalizada',
                        'etapa': '1'
                      });
                      // gtd -> inicio de etapa 2 (diagnóstico)
                      dataLayerTag({
                        'event': 'etapa_2_llegada',
                        'etapa': '2'
                      });
                    }}
                    disabled={this.props.estadoProceso !== 1 || !this.props.esEncargado}
                  > Siguiente
                  </button>
                </div>
              </div>
          </div>
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  habilitarTokenEncuesta: state.planMovilidad.habilitarTokenEncuesta,
  estadoEjecucion: state.planMovilidad.estadoEjecucion,
  estadoPlan: state.planMovilidad.estadoPlan,
  estadoProceso: state.planMovilidad.estadoProceso,
  listaContenidos: state.planMovilidad.listaContenidos,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainSensibilizacionPlanMovilidad);
